import { AxiosConfig } from "./AxiosConfig";
import { ResponseObject } from "../models/ResponseObject";
import { RequestType } from "../models/RequestType";
import { ApprovalStatusData } from "../models/Approval/ApprovalStatusData";
import { CheckListItem } from "../models/CheckListItem";
import { WorkflowApproval } from "../models/WorkflowApproval";
import qs from "qs";

// const GetVendorListItem = async (
//   successCallback: (resposeObj: ResponseObject) => void,
//   errorCallback: (error: Error) => void
// ) => {
//   try {
//     const resp = await AxiosConfig.get("/Request/GetVendorListItems");
//     successCallback(resp.data);
//   } catch (err: any) {
//     // Handle Error Here
//     console.error(err);
//     errorCallback(err);
//   }
// };

const ReSendVendorEmail = async (
  requestId:number,
  successCallback: (resposeObj: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Vendor/ReSendVendorEmail", { 
      params : {requestId: requestId }
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetVendorList = async (
  filterData: any,
  successCallback: (resposeObj: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post("/Request/GetVendorList", filterData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const SetApprovalStatus = async (
  approvalData: ApprovalStatusData,
  successCallback: (sucresponse: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(
      "/Request/SetApprovalStatus",
      approvalData
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};


const GetCompareVendorRequest = async (
  requestId: number,
  vendorId: number,
  successCallback: (resposeObj: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Request/GetCompareVendorRequest", {
      params: { requestId: requestId, vendorId:vendorId },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetCheckList = async (
  requestId: number,
  successCallback: (data: Array<CheckListItem>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Request/GetCheckList", {
      params: { requestId: requestId },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetCompareVendorBanksRequest = async (
  vendorId: number,
  successCallback: (resposeObj: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Request/GetCompareVendorBanksRequest", {
      params: {vendorId:vendorId },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const GetWorkflowApprovals = async (
  vendorCategoryId: number, 
  isBulk: boolean, 
  isInnovationOrNominated: boolean,
  requestTypeId: number,
  spendManagedById: number | null,
  successCallback: (data: Array<WorkflowApproval>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get("/Request/GetWorkflowApprovals", {
      params:  { 
        vendorCategoryId:vendorCategoryId, 
        isBulk: isBulk, 
        isInnovationOrNominated: isInnovationOrNominated, 
        requestTypeId: requestTypeId,
        spendManagedById: spendManagedById || 0 
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};


export const RequestService = {
  //GetVendorListItem,
  GetVendorList,
  SetApprovalStatus,
  GetCompareVendorRequest,
  GetCompareVendorBanksRequest,
  ReSendVendorEmail,
  GetCheckList,
  GetWorkflowApprovals
};
